/**
 * query-defaults.ts — TanStack Query global retry siyosati
 *
 * Qoidalar:
 *   - 4xx (client error) — hech qachon retry qilinmaydi. Auth, permission,
 *     validation va not-found xatolari deterministik — qayta urinish foyda
 *     bermaydi va cheksiz polling loop'larga olib keladi.
 *   - Boshqa hollar (5xx, network, noma'lum) — bir marta retry, keyin to'xtaydi.
 */

import axios from 'axios';

import { ApiClientError } from './api-client';

const MAX_RETRIES = 1;

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  const status = errorStatus(error);
  if (status !== null && status >= 400 && status < 500) {
    return false;
  }
  return failureCount < MAX_RETRIES;
}

function errorStatus(error: unknown): number | null {
  if (error instanceof ApiClientError) return error.statusCode;
  if (axios.isAxiosError(error) && error.response) return error.response.status;
  return null;
}
